module.exports = __webpack_public_path__ + "static/assets/f0a5f0099248b3299d160c3e2527b79a.png";